<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

/**
 * A quantity picker. A select rather than a number field: every value it can
 * produce is valid, so a count can never be the reason a result disappears.
 */
const props = withDefaults(
  defineProps<{
    modelValue: number
    max: number
    min?: number
    /** Accessible name; the visible label usually names the part, not the count. */
    label: string
    id: string
  }>(),
  { min: 0 },
)
const emit = defineEmits<{ 'update:modelValue': [number] }>()

const { n } = useI18n()

const options = computed(() =>
  Array.from({ length: props.max - props.min + 1 }, (_, index) => props.min + index),
)

function onChange(event: Event): void {
  const target = event.target
  if (!(target instanceof HTMLSelectElement)) return
  emit('update:modelValue', Number(target.value))
}
</script>

<template>
  <select
    :id="id"
    class="count-select mono"
    :value="modelValue"
    :aria-label="label"
    @change="onChange"
  >
    <option v-for="value in options" :key="value" :value="value">{{ n(value) }}</option>
  </select>
</template>
